// ABOUTME: Registry of sidepanels that can be deep-linked / opened in a popout tab.
// ABOUTME: Maps a short url key to its lazy component and the id prop the panel expects.

import SidepanelLoader from '../../../theme/sidepanel2/SidepanelLoader';

export const SIDEPANEL_KEYS = {
    ORDER: 'order',
    PRODUCT: 'product',
    VPRODUCT: 'vproduct',
};

// Only order / product / virtual-product are registered for now; add more entries here as
// other Sp* panels become deep-linkable.
export const sidepanelRegistry = {
    [SIDEPANEL_KEYS.ORDER]: {
        Component: SidepanelLoader(() => import('../SpOrderDetails/SpOrderDetails')),
        idProp: 'orderId',
    },
    [SIDEPANEL_KEYS.PRODUCT]: {
        Component: SidepanelLoader(() => import('../SpStockDetails/SPStockDetails')),
        idProp: 'productId',
    },
    [SIDEPANEL_KEYS.VPRODUCT]: {
        Component: SidepanelLoader(() => import('../SpVirtualProductDetails/SpVirtualProductDetails')),
        idProp: 'virtualProductId',
    },
};
